import jQuery from "jquery";
Object.assign(window, { $: jQuery, jQuery });

import "flatpickr";
import "flatpickr/dist/l10n/fr.js";
import "flatpickr/dist/l10n/zh.js";
import "lazysizes/plugins/bgset/ls.bgset.js";
import "lazysizes";
import "swiper";
import "@lottiefiles/lottie-player";

import "./jquery.blockUI";
import "./jquery.bxslider-rahisified";
import "./jquery.fitvids";
import "./jquery.maskmoney";
import "./jquery.modal";
import "./jquery.screwdefaultbuttonsV2";
import "./jquery.scrolltabs";
import "./mwheelIntent";

export default {};
